import React from 'react';

// Step indicator, step content and Back/Finish navigation shared by all
// resource wizards (graves, size figures, ...).
export default function WizardShell({ steps, labels = {}, step, setStep, onFinish, children }) {
  const stepIndex = steps.indexOf(step);
  const isLast = stepIndex === steps.length - 1;

  return (
    <div className="wizard-container">
      <div className="wizard-steps">
        {steps.map((name, index) => (
          <React.Fragment key={name}>
            <div
              className={`wizard-step ${step === name ? 'active' : ''} ${
                index < stepIndex ? 'completed' : ''
              }`}
              onClick={() => setStep(name)}
            >
              <span className="step-number">{index + 1}</span>
              <span className="step-label">{labels[name] || name.replace('_', ' ')}</span>
            </div>
            {index < steps.length - 1 && (
              <div className={`wizard-connector ${index < stepIndex ? 'completed' : ''}`} />
            )}
          </React.Fragment>
        ))}
      </div>

      <div className="wizard-content">{children}</div>

      {(stepIndex > 0 || (isLast && onFinish)) && (
        <div className="wizard-nav">
          {stepIndex > 0 && (
            <button className="btn btn-secondary" onClick={() => setStep(steps[stepIndex - 1])}>
              Back
            </button>
          )}
          {isLast && onFinish && (
            <button className="btn btn-secondary" onClick={onFinish}>
              Finish
            </button>
          )}
        </div>
      )}
    </div>
  );
}
